goog.provide('el8.appchart.dialog.ordermed.DecisionSupport');

goog.require('el8.practicedata.rxSigs');
goog.require('el8.ptdata.ptIntolerances');
goog.require('el8.ptdata.ptAllergies');
goog.require('el8.appshared.drugIntxns');
goog.require('el8.appshared.medOrderCQMCDS');
goog.require('el8.appchart.dialog.ordermed.ignoreIntxnReason');
goog.require('el8.appshared.formulary');
goog.require('el8.template.render.formulary');
goog.require('el8.ptdata.eligibilities');
goog.require('el8.data.medications');
goog.require('el8.service.urls');
goog.require('el8.util.consts');
goog.require('el8.data.decisionSupports');



el8.appchart.dialog.ordermed.DecisionSupport = function(spec) {
    // spec.main is the base medication form object (el8.appchart.dialog.ordermed.base)
    this._main = spec.main;
};

/**
 * Main methods
 */
el8.appchart.dialog.ordermed.DecisionSupport.prototype.lookup = function(successCb) {
    this.lookupFormulary(successCb);
    this.lookupInteractions(successCb);
    this.lookupCommonSigs(successCb);
    this.lookupCQMCDS(successCb);
};
el8.appchart.dialog.ordermed.DecisionSupport.prototype.reset = function() {
    this.resetFormulary();
    this.resetInteractions();
    this.resetCommonSigs();
    this.resetCQMCDS();
};

/**
 * Display reference information about patient
 */
el8.appchart.dialog.ordermed.DecisionSupport.prototype.displayReferenceInfo = function() {

    /**
     * Do all the styling of the way allergies + drug intols are displayed
     */
    if (this._main._optDivs['patientInfo']) {

        var patientInfoDiv = this._main._optDivs['patientInfo'];
        var makeContainerRed = false;

        /**
         * Update display
         */
        $('.allergy-values', patientInfoDiv).text(el8.ptdata.ptAllergies.getSummary());
        $('.intolerance-values', patientInfoDiv).html(el8.ptdata.ptIntolerances.getSummary());


        // If there are no known allergies, then make grey
        if (el8.ptdata.ptAllergies.isDocumentedAsNone()) {
            $('.pt-allergies', patientInfoDiv).addClass('el8555');
        } else { // else, make red if there are known allergies OR if they are unknown!
            makeContainerRed = true;
            $('.pt-allergies', patientInfoDiv).removeClass('el8555');
        }

        if (makeContainerRed) {
            patientInfoDiv.addClass('alert');
        } else {
            patientInfoDiv.removeClass('alert');
        }

        // If patient intols is more than 5 a toggles will appear to show the remaining intols.
        if (el8.ptdata.ptIntolerances.all().length > 5) {

            var comma = patientInfoDiv.find('.comma-separator');
            var moreIntols = patientInfoDiv.find('.more-intols');
            var moreIntolsTrigger = patientInfoDiv.find('.more-intols-trigger');

            comma.hide();
            moreIntols.hide();

            $(patientInfoDiv)
                .on('click', '.more-intols-trigger',  function(e) {
                    comma.show();
                    moreIntols.show();
                    moreIntolsTrigger.hide();
                    return false;
                })
                .on('click', '.less-intols-trigger',  function(e) {
                    comma.hide();
                    moreIntols.hide();
                    moreIntolsTrigger.show();
                    return false;
                });
        }
    }

};


/**
 * Drug-drug and drug-allergy interactions
 */
el8.appchart.dialog.ordermed.DecisionSupport.prototype.lookupInteractions = function(successCb) {
    if ((this._main._selected['medication'] || this._main._selected['newMedicationName']) &&
            this._main._optDivs['intxns']) {
        el8.appshared.drugIntxns.lookup(
            this._main._selected['medication'] ? this._main._selected['medication'].getId() : null,
            this._main._selected['medication'] ? this._main._selected['medication'].getBrandName() :
                this._main._selected['newMedicationName'],
            this._main._optDivs['intxns'],
            successCb
        );
    }
};

/**
 * CDS based on el8 CQM
 */
el8.appchart.dialog.ordermed.DecisionSupport.prototype.lookupCQMCDS = function(successCb) {

    el8.appshared.medOrderCQMCDS.lookup(
        this._main._selected['medication'] ? this._main._selected['medication'].getId() : null,
        this._main._selected['medication'] ? this._main._selected['medication'].getBrandName() :
            this._main._selected['newMedicationName'],
        this._main._optDivs['cqmCDS'],
        successCb
    );
};


el8.appchart.dialog.ordermed.DecisionSupport.prototype.resetInteractions = function() {
    if (this._main._optDivs['intxns']) { this._main._optDivs['intxns'].empty(); }
    el8.appshared.drugIntxns.reset();
};
el8.appchart.dialog.ordermed.DecisionSupport.prototype.validateInteractions = function(model,
        saveCallbackFn, hideCallbackFn, overrideText) {
    var that = this;
    if (el8.appshared.drugIntxns.getMajorIntxns() && !that._main._data['intxns_info']) {
        el8.appchart.dialog.ordermed.ignoreIntxnReason.show({
            model: model,
            majorIntxns: el8.appshared.drugIntxns.getMajorIntxns(),
            hasPrescriptionNote: Boolean(this._main._optFields['pharmacyInstr']),
            overrideText: overrideText,
            saveCallbackFn: function(reason, pharmacyNote) {
                that._main._data['intxns_info'] = {
                    'ignore_major_intxn_reason': reason,
                    'displayed_drug_drug_major_intxn_msgs':
                        $('.major-drug-drug-interactions', that._main._container)
                            .find('.alert-text').text(),
                    'displayed_drug_allergy_intxn_msgs':
                        $('.drug-allergy-interactions', that._main._container)
                            .find('.alert-text').text(),
                    'medispan_drug_drug_major_intxn_msgs':
                        el8.appshared.drugIntxns.getMajorIntxnsMsgs() ?
                        el8.appshared.drugIntxns.getMajorIntxnsMsgs()['drugDrug'] : null,
                    'medispan_drug_allergy_intxn_msgs':
                        el8.appshared.drugIntxns.getMajorIntxnsMsgs() ?
                        el8.appshared.drugIntxns.getMajorIntxnsMsgs()['drugAllergy'] : null,
                    'full_medispan_drug_drug_major_intxn_json':
                        el8.appshared.drugIntxns.getMajorIntxns() ?
                        el8.appshared.drugIntxns.getMajorIntxns()['drugDrug'] : null,
                    'full_medispan_drug_allergy_intxn_json':
                        el8.appshared.drugIntxns.getMajorIntxns() ?
                        el8.appshared.drugIntxns.getMajorIntxns()['drugAllergy'] : null,
                    'full_displayed_drug_drug_major_intxn_msgs':
                        $('.major-drug-drug-interactions', that._main._container).html(),
                    'full_displayed_drug_allergy_major_intxn_msgs':
                        $('.drug-allergy-interactions', that._main._container).html()
                };
                if (pharmacyNote && that._main._optFields['pharmacyInstr']) {
                    that._main._optFields['pharmacyInstr'].setVal(pharmacyNote);
                }
                if (saveCallbackFn) { saveCallbackFn(); }
            },
            hideCallbackFn: hideCallbackFn
        });
        return false;
    } else {
        return true;
    }
};

/**
 * Formulary information
 */
el8.appchart.dialog.ordermed.DecisionSupport.prototype.lookupFormulary = function(successCb) {
    if (!el8Globals['FEATURES']['ERx']) { return; }
    if (this._main._optDivs['formulary'] && this._main._selected['medication']) {
        var that = this;
        this._main._optDivs['formulary'].addClass('formularyLoading').empty();

        el8.appshared.formulary.lookup(
            el8.ptdata.currPatient.getId(),
            that._main._selected['medication'].getId(),
            function(data) {

                that._main._optDivs['formulary'].html(
                    el8.template.render.formulary.rxFormEligibility(data)
                ).show().removeClass('formularyLoading');

                if (successCb) { successCb(); }
            }
        );
    }
};

el8.appchart.dialog.ordermed.DecisionSupport.prototype.resetCQMCDS = function() {
    el8.appshared.medOrderCQMCDS.reset();
};

el8.appchart.dialog.ordermed.DecisionSupport.prototype.resetFormulary = function() {
    if (this._main._optDivs['formulary']) {
        if (!el8.ptdata.eligibilities.all().length &&
                !el8.ptdata.eligibilities.isLoaded()) {
            el8.ptdata.eligibilities.load(null, false);
        }
        this._main._optDivs['formulary'].html(el8.template.render.formulary.rxFormInitial({
            hasEligibility: el8.ptdata.eligibilities.hasValid()
        }));
    }
};



el8.appchart.dialog.ordermed.DecisionSupport.prototype.initCQMCDS = function() {
    /**
     * Synchronously fetch CDSs so that they are loaded up
     * when the order form is loaded
    */
    el8.data.decisionSupports.softLoad();
};

el8.appchart.dialog.ordermed.DecisionSupport.prototype.initFormulary = function() {
    if (el8Globals['FEATURES']['ERx'] && this._main._optDivs['formulary']) {
        var formularyDiv = this._main._optDivs['formulary'];
        var that = this;
        var $formularyDiv = $(formularyDiv[0]);
        $formularyDiv.on('change', ':input[name="eligibilities"]', function() {
            var id = $(this).val();
            $('.formulary-eligibility', that._main._container).hide();
            $('#meds-form-eligibility-'+id, that._main._container).show();
            if (that._main.adjustHeight) { that._main.adjustHeight(); }
        });
        $formularyDiv.on('click', '.coverage-detail-trigger', function(e) {
            var detailDiv = $(this).parent().next('.coverage-detail');
            if (detailDiv.is(':hidden')) {
                $(this).text('hide coverage detail');
                detailDiv.show();
            } else {
                $(this).text('view coverage detail');
                detailDiv.hide();
            }
        });
        $formularyDiv.on('click', '.formulary-alt-trigger', function(e) {
            var medicationId = $(this).attr('_item_id')*1;
            that._main._selected['medication'] = el8.data.medications.getById(medicationId);
            that._main._requiredFields['medication'].setVal(
                that._main._selected['medication'].getCleanName()
            );
            that._main.updateTypeDiv({'medication': that._main._selected['medication']});
            that.lookup();
            return false;
        });
        this.resetFormulary();
    }
};
el8.appchart.dialog.ordermed.DecisionSupport.prototype.getFormularyPackagedMedId = function() {
    // Get medication id from currently displayed eligibility
    //  - stored in a hidden span in formulary div
    if (this._main._optDivs['formulary']) {
        var id = $('.formulary-eligibility:visible', this._main._optDivs['formulary'])
            .find('.packaged-medication-id').text();
        return id;
    }
    return null;
};
el8.appchart.dialog.ordermed.DecisionSupport.prototype.getFormularyEligibilityId = function() {
    // Get ID of currently displayed eligibility
    if (this._main._optDivs['formulary']) {
        // If there are multiple choices, we'll have a select box
        var id = $(':input[name="eligibilities"]', this._main._optDivs['formulary']).val();
        // Else, we'll just have a div
        if (!id) { id = $('.eligibility-id', this._main._optDivs['formulary']).text(); }
        return id;
    }
    return null;
};

/**
 * Common sigs
 */
el8.appchart.dialog.ordermed.DecisionSupport.prototype.lookupCommonSigs = function() {

    if (this._main._selected['medication'] || this._main._selected['newMedicationName']) {

        // We assume that we are only submitting one medication
        var that = this;
        var selectedMedication = this._main._selected['medication'];

        var dataDict = {};
        dataDict['pt_dob'] =
            el8.ptdata.currPatient.getDob().asStringFormat('yyyy-mm-dd');
        if (selectedMedication) {
            if (selectedMedication.getMedispanddid()) {
                dataDict['source_type'] = 'medispanDDID'
                dataDict['source_id'] = selectedMedication.getMedispanddid()
            } else {
                dataDict['source_type'] = 'medicationName'
                dataDict['source_id'] = selectedMedication.getBrandName()
            }
        } else {
            dataDict['source_type'] = 'medicationName'
            dataDict['source_id'] = this._main._selected['newMedicationName']
        }

        $.el8_ajax({
          url: '/rx-sigs-for-med/',
          data: dataDict,
          success: function(data) {
              var medispanSigs = data.default_sigs;
              var favSigs = data.custom_sigs.map(function (sig){ return sig.directions });

              // save these on the dialog.ordermed.base object
              that._main._medispanSigs = medispanSigs;
              that._main._medispanSigSourceId = dataDict['source_id'];
              that._main._medispanSigSourceType = dataDict['source_type']; // "medispanDDID"
              that._main._sigs = favSigs;
              // UI: would be nice to have a seperator

              // decorate with type info to show user tag in autocomplete
              var favSigsForMindreader = favSigs.map(function (sigStr) {
                return {sig: sigStr, type: 'user'};
              });

              var medispanSigsForMindreader = medispanSigs.map(function (sigStr) {
                return {sig: sigStr, type: 'medispan'};
              });

              that._main._mindreaders['directions'].updateSearchData(
                favSigsForMindreader.concat(medispanSigsForMindreader)
              );
          }
        });
    }
};
el8.appchart.dialog.ordermed.DecisionSupport.prototype.resetCommonSigs = function() {
    if (this._main._mindreaders['directions']) {
        this._main._mindreaders['directions'].updateSearchData([]);
    }
};
